module.exports = __webpack_public_path__ + "static/media/im_loading.24034faf.svg";